import React, { useState } from 'react';
import classnames from 'classnames';
import LayoutDashboard from '../layout/LayoutDashboard';
import { Icon } from '@iconify/react';
import searchOutlined from '@iconify/icons-ant-design/search-outlined';
import DynamicScrollToTop from '../components/misc/DynamicScrollToTop';
import PaginationDashboard from '../components/misc/PaginationDashboard';
// import edit icon
import { ReactComponent as IconEdit } from '../assets/icons/bxs-pencil.svg';
const Withdrawal = ({
  ListWithdraw = [
    {
      date: '20 Okt 2020',
      telp: '08214343838',
      bank: 'BCA',
      rekening: '302020202',
      name: ' Julie estel',
      nominal: '20.000',
      status: 'cancel',
    },
    {
      date: '21 Okt 2020',
      telp: '08214343838',
      bank: 'BCA',
      rekening: '302020202',
      name: ' Julie estel',
      nominal: '20.000',
      status: 'cancel',
    },
    {
      date: '22 Okt 2020',
      telp: '08214343838',
      bank: 'BCA',
      rekening: '302020202',
      name: ' Julie estel',
      nominal: '20.000',
      status: 'cancel',
    },
    {
      date: '23 Okt 2020',
      telp: '08214343838',
      bank: 'BCA',
      rekening: '302020202',
      name: ' Julie estel',
      nominal: '20.000',
      status: 'success',
    },
    {
      date: '24 Okt 2020',
      telp: '08214343838',
      bank: 'BCA',
      rekening: '302020202',
      name: ' Julie estel',
      nominal: '20.000',
      status: 'success',
    },
    {
      date: '25 Okt 2020',
      telp: '08214343838',
      bank: 'BCA',
      rekening: '302020202',
      name: ' Julie estel',
      nominal: '20.000',
      status: 'cancel',
    },
    {
      date: '26 Okt 2020',
      telp: '08214343838',
      bank: 'BCA',
      rekening: '302020202',
      name: ' Julie estel',
      nominal: '20.000',
      status: 'success',
    },
  ],
}) => {
  const [listData, setListData] = useState(ListWithdraw);
  const [toggleEditBtnIndex, setToggleEditBtnIndex] = useState(null);
  const [toggleEditStatusIndex, setToggleEditStatusIndex] = useState(null);

  const toggleEdit = (editIndex) => {
    if (toggleEditBtnIndex === editIndex) {
      setToggleEditBtnIndex(null);
      setToggleEditStatusIndex(null);
    } else setToggleEditBtnIndex(editIndex);
  };
  const toggleStatusEdit = (editIndex) => {
    if (toggleEditStatusIndex === editIndex) setToggleEditStatusIndex(null);
    else setToggleEditStatusIndex(editIndex);
  };
  return (
    <>
      <DynamicScrollToTop />
      <LayoutDashboard>
        <section className="ml-4 w-full">
          <div className="md-flex">
            <div className="bg-white">
              <div class="mb-4">
                <div className="flex align-middle rounded-tl-lg rounded-tr-lg w-full py-4 overflow-hidden bg-white shadow-lg px-12 mr-auto">
                  <div class="flex">
                    <input
                      class="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                      type="text"
                      placeholder="Pencarian"
                      aria-label="Full name"
                    />
                    <button className="bg-green-100 text-white font-bold py-2 px-4 rounded">
                      <Icon
                        icon={searchOutlined}
                        className="text-2xl text-white"
                      />
                    </button>
                  </div>
                  {/* <button className="bg-orange-500 text-white font-bold py-2 px-4 rounded ml-auto">
                    + Rekening Baru
                  </button> */}
                </div>
              </div>
            </div>
          </div>
          <div className="md-flex">
            <div className="bg-white">
              <div className="py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 pr-10 lg:px-8">
                <div className="align-middle rounded-tl-lg rounded-tr-lg inline-block w-full py-4 overflow-hidden bg-white shadow-lg px-12"></div>
                <div className="align-middle inline-block w-full shadow overflow-hidden bg-white shadow-dashboard px-8 pt-3 rounded-bl-lg rounded-br-lg">
                  <table className="w-full">
                    <thead>
                      <tr>
                        <th className="bg-gray-300 px-8 py-4  border-gray-300 text-left leading-4 text-gray-600 tracking-wider">
                          #
                        </th>
                        <th className="bg-gray-300 px-8 py-4 border-gray-300 text-left leading-4 text-gray-600 tracking-wider">
                          Tanggal
                        </th>
                        <th className="bg-gray-300 px-8 py-4 border-gray-300 text-left leading-4 text-gray-600 tracking-wider">
                          Nomor telepon
                        </th>
                        <th className="bg-gray-300 px-8 py-4 border-gray-300 text-left leading-4 text-gray-600 tracking-wider">
                          Bank
                        </th>
                        <th className="bg-gray-300 px-8 py-4 border-gray-300 text-left leading-4 text-gray-600 tracking-wider">
                          Nomor rekening
                        </th>
                        <th className="bg-gray-300 px-8 py-4 border-gray-300 text-left leading-4 text-gray-600 tracking-wider">
                          Atas nama
                        </th>
                        <th className="bg-gray-300 px-8 py-4 border-gray-300 text-left leading-4 text-gray-600 tracking-wider">
                          Nominal
                        </th>
                        <th className="bg-gray-300 px-8 py-4 border-gray-300 text-left leading-4 text-gray-600 tracking-wider">
                          Status
                        </th>
                        <th className="bg-gray-300 px-8 py-4 border-gray-300 text-left leading-4 text-gray-600 tracking-wider">
                          Tindakan
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white">
                      {listData.map((listDatas, index) => (
                        <tr key={index}>
                          <td className="px-6 py-4 whitespace-no-wrap  border-gray-500">
                            <div className="flex items-center">
                              <div>
                                <div className="text-sm leading-5 text-gray-800">
                                  {++index}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-no-wrap border-gray-500">
                            <div className="text-sm leading-5 text-gray-600">
                              {listDatas.date}
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-no-wrap text-blue-900 border-gray-600 text-sm leading-5">
                            {listDatas.telp}
                          </td>
                          <td className="px-6 py-4 whitespace-no-wrap text-blue-900 border-gray-600 text-sm leading-5">
                            {listDatas.bank}
                          </td>
                          <td className="px-6 py-4 whitespace-no-wrap  text-blue-900 border-gray-600 text-sm leading-5">
                            {listDatas.rekening}
                          </td>
                          <td className="px-6 py-4 whitespace-no-wrap border-gray-500 text-gray-600 text-sm leading-5">
                            {listDatas.name}
                          </td>
                          <td className="px-6 py-4 whitespace-no-wrap border-gray-500 text-gray-600 text-sm leading-5">
                            Rp {listDatas.nominal}
                          </td>
                          <td className="px-4 py-4 whitespace-no-wrap  border-gray-500 text-gray-600 text-sm leading-5">
                            <p
                              className={classnames(
                                ' leading-5 text-center rounded-md capitalize px-2 ',
                                {
                                  'text-red-500 bg-red-200':
                                    listDatas.status === 'cancel',
                                  'text-green-500 bg-green-200':
                                    listDatas.status === 'success',
                                }
                              )}
                            >
                              {' '}
                              {listDatas.status === 'success'
                                ? 'Terbayarkan'
                                : 'Dibatalkan'}
                            </p>
                          </td>

                          <td className="  px-6 py-4 text-left leading-4 text-gray-600 tracking-wider ">
                            <div className="flex w-full items-center justify-center relative">
                              <button
                                className="mx-1"
                                onClick={() => {
                                  toggleStatusEdit(index);
                                }}
                              >
                                <IconEdit className="h-4 w-4 text-basic-orange" />
                              </button>
                              {toggleEditStatusIndex === index && (
                                <div className="origin-top-right absolute right-0 -ml-10 mr-8  w-28 rounded-md shadow-lg">
                                  <div className="rounded-md bg-white shadow-sm py-2 px-3">
                                    <div
                                      className="py-1 flex flex-col "
                                      role="menu"
                                      aria-orientation="vertical"
                                      aria-labelledby="options-menu"
                                    >
                                      <button
                                        className="text-sm text-left px-3 py-2 rounded-md hover:bg-orange-200 hover:text-basic-orange"
                                        onClick={() => {
                                          toggleEdit(index);
                                        }}
                                      >
                                        Disetujui
                                      </button>
                                      <button
                                        className="text-sm text-left px-3 py-2 rounded-md hover:bg-orange-200 hover:text-basic-orange"
                                        onClick={() => {
                                          toggleStatusEdit(index);
                                        }}
                                      >
                                        Dibatalkan
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )}
                              {toggleEditBtnIndex === index && (
                                <div className="origin-top-right absolute right-0 -mt-10 mr-8  w-64 rounded-md shadow-lg">
                                  <div className="rounded-md bg-white shadow-xs  py-2 shadow-sm">
                                    <div
                                      className="py-1"
                                      role="menu"
                                      aria-orientation="vertical"
                                      aria-labelledby="options-menu"
                                    >
                                      <div className="flex flex-col px-4 py-2 flex-wrap justify-between">
                                        <p className="text-sm font-semibold">
                                          Yakin ingin membayar transaksi ini?
                                        </p>
                                        <div className="flex ml-auto mt-6">
                                          <button
                                            className="text-sm bg-white border border-gray-500 mx-2 px-3 py-1 rounded"
                                            onClick={() => {
                                              toggleEdit(index);
                                            }}
                                          >
                                            Tidak
                                          </button>
                                          <button
                                            className="text-sm text-white bg-green-500 border border-bg-green-700 px-3 py-1 rounded"
                                            onClick={() => {
                                              toggleEdit(index);
                                            }}
                                          >
                                            Ya
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="sm:flex-1 sm:flex sm:items-center sm:justify-between mt-4 work-sans float-right">
                    <div>
                      <PaginationDashboard />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </LayoutDashboard>
    </>
  );
};

export default Withdrawal;
